import * as zod from 'zod'

export const editPaymentMethodFlowSchema = zod
  .object({
    chargeUpfront: zod.boolean(),
    invoiceDueDays: zod.coerce.number().min(0).optional(),
    currentValues: zod.object({
      chargeUpfront: zod.boolean(),
      invoiceDueDays: zod.number().optional(),
    }),
  })
  .superRefine((data, ctx) => {
    const chargeUpfrontChanged =
      data.chargeUpfront !== data.currentValues.chargeUpfront
    const invoiceDueDaysChanged =
      data.invoiceDueDays !== data.currentValues.invoiceDueDays

    if (!chargeUpfrontChanged && !invoiceDueDaysChanged) {
      ctx.addIssue({
        code: zod.ZodIssueCode.custom,
        message:
          'No changes detected. Please modify at least one field to save.',
        path: ['currentValues'],
      })
    }
  })

export type EditPaymentMethodFlowSchema = zod.infer<
  typeof editPaymentMethodFlowSchema
>
